<template>
  <div>
    <div class="bg-charcoal-100 dark:bg-dark-950">
      <div class="max-w-wrapper-3xs mx-auto font-medium leading-snug p-4 text-center">
        <BlockCompleteProfile @success="() => emit('next')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Event } from '@/classes'

const props = defineProps<{
  event: Event
}>()

const emit = defineEmits<{
  (e: 'next'): void
}>()

</script>